/**
 * Sliders
 *
 * Gestion des sliders
 * bug on rezise see -> https://github.com/kenwheeler/slick/issues/542#issuecomment-168658956
 */
require('slick-carousel');
require('bootstrap');
import breakpoints from '../misc/breakpoints';

const modelCarouselMobile = $('[data-role="model-carousel-mobile"]');
const modelCarouselPresentation = $('[data-role="model-carousel-presentation"]');
const modelCarouselPresentationSmall = $('[data-role="model-carousel-presentation-small"]');
const carouselInspiration = $('[data-role="carousel-inspiration"]');
const carouselUpsel = $('[data-role="carousel-upsel"]');
const carouselPresentation = $('[data-role="model-carousel-desktop"]')
const carouselPresentationSync = $('[data-role="model-carousel-desktop-sync"]')


let isInitMobile = false;
let isInitDesktop = false;
//mobile and desktop
let isInitCarousel = false;

initSlider();

function initSlider() {

  // mobile and dekstop
  if(!isInitCarousel) {
    modelCarouselPresentation.slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      focusOnSelect: true,
      infinite: false,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            arrows: true,
            centerMode: true,
            slidesToShow: 1,
            centerPadding: "150px"
          }
        }
      ]
    });

    modelCarouselPresentationSmall.slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      focusOnSelect: true,
      infinite: false,
      dots: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            arrows: true,
            centerMode: true,
            slidesToShow: 1,
            centerPadding: "100px"
          }
        }
      ]
    });

    isInitCarousel = true;
  }

  // carousel on dekstop and not on mobile
  if(breakpoints.isDesktopLarge() && !isInitDesktop) {
    isInitDesktop = true;

    carouselPresentation.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '[data-role="model-carousel-desktop-sync"]'
    });

    carouselPresentationSync.slick({
      slidesToShow: 4,
      arrows: true,
      vertical: true,
      slidesToScroll: 1,
      focusOnSelect: true,
      asNavFor: '[data-role="model-carousel-desktop"]'
    });

  } else if (breakpoints.isMobileLarge() && isInitDesktop){

    isInitDesktop = false;

    carouselPresentation.slick('unslick');
    carouselPresentationSync.slick('unslick');

  }

  // carousel on mobile and not on desktop
  if(breakpoints.isMobileLarge() && !isInitMobile) {
    modelCarouselMobile.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      focusOnSelect: true,
      infinite: true,
      dots: true,
      arrows: false
    });

    carouselInspiration.slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      mobileFirst: true,
      focusOnSelect: true,
      infinite: false,
      arrows:false,
      rows: 0,
      slide: '.slide'
    });

    carouselUpsel.slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      arrows: false,
      mobileFirst: true,
      focusOnSelect: true,
      infinite: false
    });

    isInitMobile = true;
  } else if (breakpoints.isDesktopLarge() && isInitMobile){
    modelCarouselMobile.slick('unslick');
    carouselInspiration.slick('unslick');
    carouselUpsel.slick('unslick');
    isInitMobile = false;
  }
}

// Resize de la fenêtre
window.addEventListener("resize", function() {
  initSlider();
  if(breakpoints.isDesktopLarge()) {
    $('[data-role="collapse-content"]').addClass('show');
  }
});


// TODO déplacer ça dans un module générique
if(breakpoints.isMobileLarge()) {
  $('[data-role="collapse"]').click(function(){
    $(this).closest('[data-role="accordion"]').find('[data-role="collapse"]').not(this).removeClass('is-toogle');
    $(this).toggleClass('is-toogle');
    $($(this).data("target")).collapse('toggle');
  });
} else {
  $('[data-role="collapse-content"]').addClass('show');
}


